import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Link from '@mui/material/Link';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import ModalRecuperarSenha from './components/ModalRecuperarSenha';
import AuthLayout from '../../components/layout/AuthLayout';
import { notify, getErrorMessage } from '../../components/feedback/notify';

function Login() {

    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [email, setEmail] = useState('');
    const [senha, setSenha] = useState('');
    const [loading, setLoading] = useState(false);
    const [modalRecuperarSenha, setModalRecuperarSenha] = useState(false);

    useEffect(() => {
        const verificarSessao = async () => {
            const token = localStorage.getItem('token');
            if (!token) return;
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/verificarTokenAdmin`, {}, {
                    headers: { Authorization: token }
                });

                if (response.data.status === 200) {
                    navigate("../dashboard")
                } else {
                    localStorage.removeItem('token');
                }
            } catch (error) {
                localStorage.removeItem('token');
            }
        }
        verificarSessao();
    }, [navigate])

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleLogin = async (event) => {
        event?.preventDefault();
        if (!email || !senha) {
            notify.warning("Informe e-mail e senha para continuar.");
            return;
        }
        try {
            setLoading(true);
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/loginAdm`, { email, senha })

            if (response.data.status === 200) {
                localStorage.setItem('token', response.data.token);
                navigate("../dashboard")
            } else {
                notify.error(response.data.message || "E-mail ou senha inválidos.", { title: "Não foi possível entrar" });
            }
        } catch (error) {
            notify.error(getErrorMessage(error, "E-mail ou senha inválidos."), { title: "Não foi possível entrar" });
        } finally {
            setLoading(false);
        }
    }

    return (
        <AuthLayout title="Entrar" subtitle="Acesse com suas credenciais de administrador.">
            <Box component="form" onSubmit={handleLogin} noValidate sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <TextField
                    label="E-mail"
                    type="email"
                    autoComplete="email"
                    fullWidth
                    size="small"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoFocus
                />
                <TextField
                    label="Senha"
                    type={showPassword ? 'text' : 'password'}
                    autoComplete="current-password"
                    fullWidth
                    size="small"
                    value={senha}
                    onChange={(e) => setSenha(e.target.value)}
                    slotProps={{
                        input: {
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                        size="small"
                                    >
                                        {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        },
                    }}
                />
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: -0.5 }}>
                    <Link component="button" type="button" variant="body2" underline="hover" color="text.secondary" onClick={() => setModalRecuperarSenha(true)}>
                        Esqueceu a senha?
                    </Link>
                </Box>
                <Button type="submit" variant="contained" fullWidth size="large" loading={loading} sx={{ mt: 1 }}>
                    Entrar
                </Button>
            </Box>
            <ModalRecuperarSenha modalRecuperarSenha={modalRecuperarSenha} setModalRecuperarSenha={setModalRecuperarSenha} />
        </AuthLayout>
    );
}

export default Login;
